import React, { useEffect, useState } from 'react';
import {
    Avatar,
    Badge,
    Button,
    Calendar,
    Card,
    Col,
    Divider,
    Form, Image,
    Input,
    notification, Rate,
    Row,
    Select,
    Skeleton, Space, Spin, Table,
    Tabs, Tag, Tooltip,
    Typography, Upload,
} from 'antd';
import { BrowserRouter as Router, NavLink, Route, Switch } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { Layout } from 'antd';
import { AuthConsumer, logout } from 'shared/contexts/AuthContext';
import {Link, useHistory} from 'react-router-dom';
import MyCourses from 'views/MyCourses/MyCourses';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';
const { Option } = Select;

const { Header } = Layout;
const { TabPane } = Tabs;

interface Props {
    location: any;
}

const { Title } = Typography;
export default function FrontendMyCourse(props: Props) {
    const { t } = useTranslation();
  const history = useHistory();
  const [activeStatus,setActiveStatus] = useState(1 as number);
  const [viewStatus,setViewStatus] = useState(1 as number);
//   const [activeStats,getActiveStatus] = useState(1 as number);
  const user = JSON.parse(localStorage.getItem('auth-token') as string)?.user;
    return (
        <div className={'profile-wrapper container-fluid pl-0 pr-0'}>
            <AuthConsumer>
                {({ isAuth, updateUser, cartTime, cart, user }) => (
                    <>
                    <div className='d-md-flex'>
                        <FrontendSidebar menuSelect={2} />
                        <div className={'profile-tab-content-div'} style={{width: '100%'}}>
                            <div className='myCourseSection mt-3'>
                                <MyCourses />
                            </div>
                        </div>
                    </div>
                    </>
                )}
            </AuthConsumer>
        </div>
    );
}
